var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.checkIfVisible())?_c('router-link',{staticClass:"pb-2",attrs:{"to":{ name: _vm.route, params: {id: _vm.itemId}, query: _vm.query },"title":_vm.$t('edytuj'),"tag":"a"}},[_c('span',{staticClass:"icon icon-edit"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }